/* eslint-disable global-require */
import Realisation from '../../types/ProjectType';

const realisations: Realisation[] = [
  {
    id: 1,
    shortname: 'watermark',
    name: 'Watermark',
    image: require('../img/projects/watermark.webp'),
    description: 'realisation.description-project-4',
    technologies: [
      'SvelteJS',
      'Typescript',
      'Electron',
      'NodeJS',
      'Docker',
      'Cypress',
      'Jest',
      'Tailwind',
    ],
    githubLink: ['https://github.com/gautierlabarre/watermark'],
  },
  {
    id: 2,
    shortname: 'GDM',
    name: 'GDM Background Login',
    image: require('../img/projects/select-background.webp'),
    description: 'realisation.description-project-3',
    technologies: ['SvelteJS', 'Electron', 'NodeJS', 'GitlabCI', 'Bootstrap'],
    githubLink: ['https://github.com/gautierlabarre/gdm-login-background'],
    downloadLink:
      'https://labarre.me/gdm-background-login/gdm-login-background.AppImage',
  },
  {
    id: 3,
    shortname: 'flutter',
    name: 'Personal Improver',
    image: require('../img/projects/login-screen-show.webp'),
    description: 'realisation.description-project-2',
    technologies: ['Flutter', 'Firebase', 'Dart', 'GitlabCI', 'Docker'],
    githubLink: ['https://github.com/gautierlabarre/test-flutter'],
    downloadLink: 'https://labarre.me/flutter-test/personalImprover.apk',
  },
  {
    id: 4,
    shortname: 'unified',
    name: 'Unified Remote Control',
    image: require('../img/projects/celluloid.webp'),
    description: 'realisation.description-project-1',
    technologies: ['Flutter', 'Firebase', 'Dart', 'GitlabCI', 'Docker'],
    githubLink: ['https://github.com/gautierlabarre/unified-remotes'],
  },
];

export default realisations;
